<template>
  <div class="video_preview_wrap">
    <div class="video_preview_box">
      <div class="video_head">
        <p class="video_name">{{videoName}}</p>
        <span class="el-icon-circle-close close_btn" @click="closeFn()"></span>
      </div>
      <video
        id="video"
        class="video-js"
        controls
        controlsList="nodownload"
        preload="auto"
        width="100%"
        :style="'height:'+videoHeight"
        data-setup='{"example_option":true}'
        ref="videoC"
      >
        <source id="sourceBox" :src="videoSrc" type="video/mp4"/>
        <p class="vjs-no-js">不支持播放</p>
      </video>
    </div>
  </div>
</template>
<script>
export default {
  props: ['videoName', 'videoSrc'],
  data(){
    return{
      videoHeight: '540px',
    }
  },
  methods: {
    closeFn(){
      this.$emit('closeFn')
    }
  }
}
</script>
<style lang="scss" scoped>
.video_preview_wrap{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba($color: #000000, $alpha: 0.6);
  z-index: 2000;
  .video_preview_box{
    width: 960px;
    height: 540px;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    .video_head{
      width: 960px;
      height: 32px;
      background: rgba(0, 0, 0, 0.6);
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 10;
      .video_name{
        width: 600px;
        font-size: 12px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 32px;
        margin-left: 20px;
      }
      .close_btn{
        color: #ffffff;
        font-size: 20px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/videoPreview.vue